import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

const Breadcrumb = ({ items }: { items: { title: string, link?: string }[] }) => {
  return (
    <nav aria-label="breadcrumb">
      <ol className="breadcrumb">
        {items.map((item, index) => (
          <li
            key={index}
            className={`breadcrumb-item ${index === items.length - 1 ? 'active' : ''}`}
            aria-current={index === items.length - 1 ? 'page' : undefined}
          >
            {item.link ? <Link to={item.link}> <FormattedMessage id={item.title} /></Link> : <FormattedMessage id={item.title} />}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
